/** Helpers for the 6 separate OTP boxes (iPhone-style, not one packed input). */

export const OTP_LENGTH = 6;

export function digitsFromValue(value: string): string[] {
  const d = String(value || "").replace(/\D/g, "").slice(0, OTP_LENGTH);
  return Array.from({ length: OTP_LENGTH }, (_, i) => d[i] ?? "");
}

export function valueFromDigits(digits: string[]): string {
  return digits.join("").replace(/\D/g, "").slice(0, OTP_LENGTH);
}

export function applyOtpPaste(text: string): { value: string; focus: number } {
  const nums = String(text || "").replace(/\D/g, "").slice(0, OTP_LENGTH);
  const focus = nums.length >= OTP_LENGTH ? OTP_LENGTH - 1 : Math.max(0, nums.length);
  return { value: nums, focus };
}

export function applyOtpInput(
  current: string,
  index: number,
  incoming: string,
): { value: string; focus: number } {
  const i = Math.max(0, Math.min(OTP_LENGTH - 1, index));
  const nums = String(incoming || "").replace(/\D/g, "");
  if (nums.length >= OTP_LENGTH) {
    return applyOtpPaste(nums);
  }
  if (nums.length > 1) {
    const digits = digitsFromValue(current);
    for (let n = 0; n < nums.length && i + n < OTP_LENGTH; n += 1) {
      digits[i + n] = nums[n];
    }
    const filled = valueFromDigits(digits);
    const focus = Math.min(i + nums.length, OTP_LENGTH - 1);
    return { value: filled, focus };
  }
  const digits = digitsFromValue(current);
  digits[i] = nums.slice(-1);
  const value = valueFromDigits(digits);
  const focus = nums ? Math.min(i + 1, OTP_LENGTH - 1) : i;
  return { value, focus };
}

export function applyOtpBackspace(
  current: string,
  index: number,
): { value: string; focus: number } {
  const i = Math.max(0, Math.min(OTP_LENGTH - 1, index));
  const digits = digitsFromValue(current);
  if (digits[i]) {
    digits[i] = "";
    return { value: valueFromDigits(digits), focus: i };
  }
  if (i > 0) {
    digits[i - 1] = "";
    return { value: valueFromDigits(digits), focus: i - 1 };
  }
  return { value: valueFromDigits(digits), focus: 0 };
}
